import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import blogApi from '../../api/Blogapi';
import { useNavigate  } from "react-router";

const Blog_card = () => {
  const [blogs, setBlogs] = useState([]);
   const navigate = useNavigate();

useEffect(() => {
    blogApi.getAll()
      .then((data) => setBlogs(data))
      .catch((error) => console.error("Error fetching blogs:", error));
  }, []);


   const getTextPreview = (html, length = 60) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > length ? text.slice(0, length) + "..." : text;
  };


  return (
    <Container>
      {/* First Row */}
      <Row className="mb-4" style={{ gap:"3rem" , marginBottom: "3rem" }}>
       
      
       {blogs .map((blog) => (
        <Col key={blog.id} lg={12} md={6} sm={12}>
          <div className="blog-card">
            <div className="blog-card-image">      
      <img src={blog.featured_image_url} alt={blog.title} />

            </div>
            <div className="blog-card-content">
              <div className="blog-card-meta">
                <span className="category">{blog.category}</span>
                <span className="date">{blog.created_at}</span>
              </div>
              <h3 className="blog-title">{blog.title}</h3>
              <p>
              {getTextPreview(blog.description, 130)}
              </p>
             
               <div className="buttonss-container-1" style={{ marginLeft: "-0.5rem" }}>
                                <span className="mass">Read More</span>
                                <button  id="work" type="button"  name="Hover" style={{  background: "linear-gradient(45deg, #002266, #000436)",  color: "white", borderRadius: "9px",  border: "none", cursor: "pointer", height: "5rem" , width: "10rem"  }} onClick={() => navigate(`/Blogs/${blog.slug}`)}>
                                  Read More
                                </button>
                              </div>
            </div>
          </div>
        </Col>
       ))};       
      </Row>
    </Container>
  );
};

export default Blog_card;
